var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.29199C5.74313 2.29199 2.29199 5.74313 2.29199 10.0003C2.29199 14.2575 5.74313 17.7087 10.0003 17.7087C14.2575 17.7087 17.7087 14.2575 17.7087 10.0003C17.7087 5.74313 14.2575 2.29199 10.0003 2.29199ZM1.04199 10.0003C1.04199 5.05277 5.05277 1.04199 10.0003 1.04199C14.9479 1.04199 18.9587 5.05277 18.9587 10.0003C18.9587 14.9479 14.9479 18.9587 10.0003 18.9587C5.05277 18.9587 1.04199 14.9479 1.04199 10.0003Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62083 6.33627C8.33377 6.57983 8.12533 6.95118 8.12533 7.50033C8.12533 7.84551 7.8455 8.12533 7.50033 8.12533C7.15515 8.12533 6.87533 7.84551 6.87533 7.50033C6.87533 6.59115 7.2398 5.86873 7.81211 5.38313C8.37084 4.90906 9.09354 4.68782 9.79199 4.68783C10.4905 4.68783 11.2132 4.90907 11.7719 5.38314C12.3442 5.86874 12.7087 6.59115 12.7087 7.50034C12.7087 8.13857 12.5452 8.6249 12.2782 9.02541C12.0538 9.36196 11.7622 9.62216 11.5328 9.82688C11.5078 9.84922 11.4835 9.87091 11.4601 9.89196C11.2041 10.1223 11.0112 10.3122 10.8698 10.5621C10.7345 10.8011 10.6253 11.135 10.6253 11.6669C10.6253 12.0121 10.3455 12.2919 10.0003 12.2919C9.65515 12.2919 9.37533 12.0121 9.37533 11.6669C9.37533 10.9489 9.52661 10.3974 9.78194 9.94632C10.0311 9.50606 10.359 9.20119 10.6239 8.96283C10.6444 8.94433 10.6645 8.92632 10.6841 8.90873C10.9343 8.68403 11.1066 8.52922 11.2381 8.33202C11.3617 8.1466 11.4587 7.90377 11.4587 7.50034C11.4587 6.95119 11.2502 6.57984 10.9632 6.33628C10.6625 6.08118 10.2394 5.93783 9.79199 5.93783C9.34461 5.93783 8.92148 6.08117 8.62083 6.33627Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4268 14.5348C10.6833 14.7658 10.7041 15.1609 10.4732 15.4175L10.4649 15.4268C10.234 15.6833 9.83879 15.7041 9.58222 15.4732C9.32565 15.2423 9.30486 14.8471 9.53577 14.5906L9.5441 14.5813C9.77501 14.3247 10.1702 14.3039 10.4268 14.5348Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.e4be3cf62016133e33e914b4da5477c1.svg";
export { ForwardRef as ReactComponent };